import { t } from "../../../../../utils/i18n";
import React from "react";

const Head = ({ cardType }) => (
  <thead style={{ backgroundColor: "#4c3f84", color: "#fff" }}>
    <tr>
      <th>{t("cards.common.date")}</th>
      <th>{t("cards.transactions.transaction_ref")}</th>
      <th>{t("cards.activities.description")}</th>
      {cardType !== "virtual" && <th>{t("cards.transactions.credit_usd")}</th>}
      <th>{t("cards.transactions.debit_usd")}</th>
      {cardType !== "virtual" && <th>{t("cards.transactions.balance_usd")}</th>}
      {cardType === "virtual" && <th>{t("cards.common.status")}</th>}
      {cardType === "virtual" && <th>{t("cards.transactions.declined_reason")}</th>}
    </tr>
  </thead>
);

export default Head;
